import { createUseStyles } from "react-jss";
import { theme } from "$utils/theme/bataillog";

export const useStyles = createUseStyles(() => ({
  beforeOpTable: {
    display: "flex",
    justifyContent: "space-between",
  },
  addRecordButtonContainer: {
    display: "flex",
    justifyContent: "flex-end",
    marginBottom: theme.spacing(2),
    marginLeft: "auto",
    marginRight: 0,
  },
  addRecordButton: {
    alignSelf: "center",
    height: 40,
  },
  opTableContainer: {
    display: "flex",
    maxHeight: 500,
  },
  subRow: {
    cursor: "default",
    borderBottom: "1px solid rgba(224, 224, 224, 1)",
    "&:hover": {
      background: theme.color.white,
    },
  },
  opParcelTitle: {
    padding: theme.spacing(1),
    fontSize: 15,
    fontWeight: "bold",
  },
  parcelTable: {
    padding: "0 40px 40px",
  },
  cell: {
    display: "flex",
    fontSize: 15,
  },
  disabledCell: {
    display: "flex",
    color: theme.color.gray3,
    fontSize: 15,
  },
  alertIcon: {
    cursor: "pointer",
    marginLeft: theme.spacing(2),
    alignSelf: "center",
    color: theme.color.orange,
  },
}));
